import React from "react";

export const RecruiterBioCard = props => {
    const {bio} = props;
    return <div className="recruiter-bio-card">
        <span className="sub-title">About</span>
        <p>{bio}</p>
    </div>
};
